import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator, fromToDate, optional } from '../../../../../../../common/forms/custom.validators';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';

@Injectable()
export class ComplaintDataForm extends AppForm {

  public appealSubjects: string[] = [
    'Całości postanowienia',
    'Części postanowienia'
  ];

  public appealRequests: string[] = [
    'Uchylenie zaskarżonego postanowienia w całości lub w części',
    'Zmianę zaskarżonego postanowienia'
  ];

  constructor() {
    super({
      decisionDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date())] }),
      decisionDeliveryDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date())] }),
      appealSubject: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      appealGroundLegalBreach: new FormControl('', {
        nonNullable: true,
        validators: [Validators.maxLength(5000)]
      }),
      appealGroundNewFacts: new FormControl('', {
        nonNullable: true,
        validators: [Validators.maxLength(5000)]
      }),

      appealRequest: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    }, {
      validators: [
        fromToDate('decisionDate', 'decisionDeliveryDate'),
        optional('appealGroundLegalBreach', 'appealGroundNewFacts')
      ]
    });
  }

  public get appealRequestDescription(): FormControl | null {
    return this.get('appealRequestDescription') as FormControl | null;
  }

  public get appealGroundNewFacts(): FormControl {
    return this.get('appealGroundNewFacts') as FormControl;
  }

  public get appealGroundLegalBreach(): FormControl {
    return this.get('appealGroundLegalBreach') as FormControl;
  }

  public get appealSubjectDescription(): FormControl | null {
    return this.get('appealSubjectDescription') as FormControl | null;
  }

  public appealSubjectChange(v: string): void {
    if (v === 'Części postanowienia') {
      this.addControl('appealSubjectDescription', new FormControl('', {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(5000)]
        })
      );
    } else {
      this.removeControl('appealSubjectDescription');
    }
  }

  public appealRequestChange(v: string): void {
    if (v === 'Zmianę zaskarżonego postanowienia') {
      this.addControl('appealRequestDescription', new FormControl('', {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(5000)]
        })
      );
    } else {
      this.removeControl('appealRequestDescription');
    }
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(value);
    super.patchFormValues(value);
    this.appealSubjectChange(value?.appealSubject || '');
    this.appealSubjectDescription?.setValue(value?.appealSubjectDescription);
    this.appealRequestChange(value?.appealRequest || '');
    this.appealRequestDescription?.setValue(value?.appealRequestDescription);
  }

}
